import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { RemoteDiagnosticsVddGenericStructure, SetNewValueObject } from '@vi-iot/client';
import { InputValuePipe } from '../../../../../../shared/pipes/input-value/input-value.pipe';

@Component({
  selector: 'app-vdd-mac-address-edit',
  templateUrl: './vdd-mac-address-edit.component.html',
  styleUrls: ['./vdd-mac-address-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddMacAddressEditComponent implements OnInit {
  @Input() structureArray: RemoteDiagnosticsVddGenericStructure[];
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  private readonly minInputChWidth = 20;
  value = '';
  mask = '';
  inputChWidth: number;
  patterns = {
    0: { pattern: new RegExp('[a-fA-F0-9]') },
  };

  constructor(private inputValuePipe: InputValuePipe) {}

  ngOnInit(): void {
    this.inputChWidth = Math.max(this.minInputChWidth, this.structureArray.length * 4 - 1);
    this.structureArray.forEach((structure, index) => {
      this.mask += index + 1 !== this.structureArray.length ? `00-` : '00';
      let structureValue = this.formatValue(structure.value.toString()).toString(16);
      structureValue = structureValue === '0' ? '00' : structureValue;
      this.value +=
        index + 1 !== this.structureArray.length ? `${structureValue}-` : structureValue;
    });
  }

  valueChange(event: Event): void {
    const newValues = this.inputValuePipe.transform(event).split('-');

    this.structureArray.forEach((structure, index) => {
      const newValueNumber = parseInt(newValues[index], 16);
      const newValue = isNaN(newValueNumber) ? '0' : newValueNumber.toString();
      this.setNewValue.emit({
        path: structure.path,
        newValue,
      });
    });
  }

  private formatValue(value: string): number {
    const number = Number(value);

    return isNaN(number) ? 0 : number;
  }
}
